import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledButtonBlack
} from "../../../styles/MyStyles";

const NationalityEditPage = () => {
    const { nationalityId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [nationality, setNationality] = useState({
        name: '',
        id: 0
    });

    useEffect(() => {
        const fetchNationality = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (nationalityId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_NATIONALITIES_URL}/${nationalityId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        const fetchedEntities = data.data;
                        setNationality(fetchedEntities);
                    } else {
                        console.log('Fetch nationality failed.');
                    }
                } else {
                    setNationality({
                        name: '',
                        id: 0
                    });
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchNationality();
    }, [nationalityId]);

    const validateForm = () => {
        let newErrors = {};

        if (!nationality.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setNationality({
            ...nationality,
            [event.target.name]: event.target.value,
        });

        setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_NATIONALITIES_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(nationality),
                }
            );
            if (response.ok) {
                console.log('Nationality updated successfully.');
                handleGoBack();
            } else {
                console.log('Update nationality failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleDelete = async () => {
        try {
            console.log(nationality);
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_NATIONALITIES_URL}/${nationality.id}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Nationality deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete nationality failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {nationalityId ? 'Edit Nationality' : 'Create Nationality'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(nationalityId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Name</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="name"
                                label="Name"
                                value={nationality.name}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default NationalityEditPage;
